import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Country, LangModel } from '../interfaces/country.interface';
import { ResponseData } from '../interfaces/response.interface';
import { BaseApi } from './base.api';

@Injectable({
  providedIn: 'root',
})
export class CountryApi extends BaseApi {
  /**
   * 获取api 请求国家数据
   *
   * @returns //
   */
  getCountries(): Observable<Country[]> {
    const url = `${environment.apiUrl}/v1/resource/country/getall`;
    return this.getByCaches<ResponseData<Country[]>>(url).pipe(
      map(x => {
        if (x?.success) return x?.data;
        return [];
      })
    );
  }

  /**
   * 获取api 所有语言
   *
   * @returns //
   */
  getalllanguage(useCache: boolean = true): Observable<LangModel[]> {
    const url = `${environment.apiUrl}/v1/resource/language/getalllanguage`;
    // useCache 为 false 时直接请求最新数据，并同时更新缓存
    const request$ = useCache
      ? this.getByCaches<ResponseData<LangModel[]>>(url)
      : this.get<ResponseData<LangModel[]>>(url, undefined, undefined, undefined, true);
    return request$.pipe(
      map(x => {
        if (x) return x.data;
        return [];
      }),
    );
  }

  // /**
  //  * 设置语言 参数
  //  *
  //  * @param langCode
  //  * @returns
  //  */
  // setLanguage(langCode: string): Observable<boolean | null> {
  //   const url = `${environment.apiUrl}/v1/resource/language/set?langCode=${langCode}`;
  //   return this.post<ResponseData<boolean>>(url).pipe(map(x => x?.data || null));
  // }
}
